<template><div><h1 id="benutzerfunktionen-zuordnen" tabindex="-1"><a class="header-anchor" href="#benutzerfunktionen-zuordnen"><span>Benutzerfunktionen zuordnen</span></a></h1>
<p>Benutzerfunktionen zuordnen — Zuordnung von Benutzerfunktionen zu Benutzergruppen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame werden den <RouteLink to="/referenz/refs/ft.refdata.benutzergruppen.html" title="Benutzergruppen">Benutzergruppen</RouteLink> die <RouteLink to="/referenz/refs/ft.refdata.benutzerfunktionen.html" title="Benutzerfunktionen">Benutzerfunktionen</RouteLink> zugewiesen.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Benutzerverwaltung → Benutzerfunktionen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Gruppe</dt>
<dd>Kurzzeichen der Gruppe</dd>
<dt>Benutzerfunktion</dt>
<dd>Kurzzeichen der Benutzerfunktion</dd>
<dt>Funktionsbezeichnung</dt>
<dd>Beschreibung der Benutzerfunktion</dd>
<dt>darf?</dt>
<dd>ja = Benutzerfunktion wird erlaubt für diese Benutzergruppe<br>nein = Benutzerfunktion wird ausgeschlossen für diese Benutzergruppe</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>keine</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/benutzerverwaltung.html#Benutzerverwaltung" title="1. Benutzerverwaltung">Benutzerverwaltung</RouteLink></p>
</div></template>


